const generateUniqueKey = (image, index) => `${image}-${index}`;

export default generateUniqueKey;
